// import React from "react";
// import {
//   Button,
//   FormFieldSet,
//   useFormHandler,
// } from "../../../../../components";
// import {
//   campaignTimings,
//   campaignTimingsZone,
// } from "../../../../../assets/data/projectData";

// const Schedule = () => {
//   const initialData = {
//     scheduleStart: "",
//     scheduleEnd: "",
//     scheduleName: "",
//     timingFrom: "",
//     timingTo: "",
//     timezone: "",
//     days: [],
//   };
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(initialData, {
//       scheduleName: { type: "text", required: true },
//     });
//     console.log("formData",formData);
//   const handleSave = () => {
//     const payload = {
//       campaign_schedule: {
//         start_date: formData.scheduleStart,
//         end_date: formData.scheduleEnd,
//         schedules: [
//           {
//             name: formData.scheduleName,
//             timing: {
//               from: formData.timingFrom,
//               to:formData.timingTo,
//             },
//             days: {
//           0: false,  // Sunday
//           1: true,   // Monday
//           2: true,   // Tuesday
//           3: true,   // Wednesday
//           4: true,   // Thursday
//           5: true,   // Friday
//           6: false   // Saturday
//         },
//         timezone:formData.timezone,
//           },
//         ],
//       },
//     };
//   };
//   return (
//     <div className="flex gap-5 mx-4 my-3 px-2 py-4 items-start  ">
//       <div className="w-fit">
//         <div className="inner-section p-4 rounded">
//           <FormFieldSet
//             title="Start Date"
//             placeholder="Select"
//             type="datepicker"
//             value={formData.scheduleStart}
//             onChange={(value) => handleChange("scheduleStart", value)}
//             error={errors.scheduleStart}
//           />
//           <FormFieldSet
//             title="End Date"
//             placeholder="Select"
//             type="datepicker"
//             value={formData.scheduleEnd}
//             onChange={(value) => handleChange("scheduleEnd", value)}
//             error={errors.scheduleEnd}
//           />
//         </div>
//         <div className="flex gap-3 my-2">
//           <Button title={"New Schedule"} size="sm" />
//           <Button
//             title={"Add Schedule"}
//             icon={"add"}
//             variant="outlined"
//             size="sm"
//           />
//         </div>
//       </div>
//       <div className="flex flex-col flex-1 gap-y-5">
//         <div className="inner-section p-3 rounded">
//           <FormFieldSet
//             title="Schedule Name"
//             placeholder="Schedule Name"
//             value={formData.scheduleName}
//             onChange={(value) => handleChange("scheduleName", value)}
//             error={errors.scheduleName}
//           />
//         </div>
//         <div className="inner-section p-3 rounded grid grid-cols-3 gap-4">
//           <FormFieldSet
//             title="Timing"
//             placeholder="From"
//             type="select"
//             value={formData.timingFrom}
//             onChange={(value) => handleChange("timingFrom", value)}
//             error={errors.timingFrom}
//             options={campaignTimings}
//             showSearch
//           />
//           <FormFieldSet
//             title=" "
//             placeholder="To"
//             type="select"
//             value={formData.timingTo}
//             onChange={(value) => handleChange("timingTo", value)}
//             error={errors.timingTo}
//             options={campaignTimings.filter((data) => data.value !== "00:30")}
//             showSearch
//           />
//           <FormFieldSet
//             title=" "
//             placeholder="Select Timezone"
//             type="select"
//             value={formData.timezone}
//             onChange={(value) => handleChange("timezone", value)}
//             error={errors.timezone}
//             options={campaignTimingsZone}
//             showSearch
//           />
//         </div>
//         <div className="inner-section p-3 rounded">
//           <FormFieldSet
//             type="checkbox"
//             size="md"
//             title="Days"
//             multiple
//             options={[
//               { label: "Monday", value: 0 },
//               { label: "Tuesday", value: 1 },
//               { label: "Wednesday", value: 2 },
//               { label: "Thursday", value: 3 },
//               { label: "Friday", value: 4 },
//               { label: "Saturday", value: 5 },
//               { label: "Sunday", value: 6 },
//             ]}
//             values={formData.days}
//             onChange={(value) => handleChange("days", value)}
//             error={errors.days}
//           />
//         </div>
//         <div className="flex justify-end">
//           <Button title={"Save"} onClick={handleSave} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Schedule;

import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../components";
import {
  campaignTimings,
  campaignTimingsZone,
} from "../../../../../assets/data/projectData";
import { successCreateInstantlyCampaign } from "../../../../../redux/slices/compaigns/compaignsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Schedule = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createCampaigns =useSelector((state) => state.compaigns?.instantly?.createCampaigns) || {};
  const initialData = {
    scheduleStart: new Date(),
    scheduleEnd: "",
    scheduleName: "",
    timingFrom: "",
    timingTo: "",
    timezone: "",
    days: [],
  };

  const initialSchedule = {
    scheduleName: "",
    timingFrom: "",
    timingTo: "",
    timezone: "",
    days: [],
  };
  const [schedules, setSchedules] = useState([initialSchedule]);

  const { formData, errors, handleChange, validateAllFields,setFormData } = useFormHandler(
    initialData,
    {
      scheduleStart: { type: "date", required: true },
      scheduleEnd: { type: "date", required: false },
      scheduleName: { type: "text", required: true },
      timingFrom: { type: "select", required: true },
      timingTo: { type: "select", required: true },
      timezone: { type: "select", required: true },
      days: { type: "select", required: true },
    }
  );
const getDaysArrayFromDayMap = (dayMap = {}) => {
  return Object.keys(dayMap)
    .filter(day => dayMap[day])
    .map(Number);
};
  const handleSave = () => {
    if (!validateAllFields()) return;
    const dayMap = {
      0: false, // Sunday
      1: false, // Monday
      2: false, // Tuesday
      3: false, // Wednesday
      4: false, // Thursday
      5: false, // Friday
      6: false, // Saturday
    };
    formData.days.forEach((day) => {
      dayMap[day] = true;
    });

    const payload = {
      campaign_schedule: {
        start_date: formData.scheduleStart.toISOString().split("T")[0],
        // end_date: formData.scheduleEnd,
        schedules: [
          {
            name: formData.scheduleName,
            timing: {
              from: formData.timingFrom,
              to: formData.timingTo,
            },
            days: dayMap,
            timezone: formData.timezone,
          },
        ],
      },
    };
    dispatch(successCreateInstantlyCampaign(payload));
    // navigate("/ats/campaigns/add-campaign#options");
    navigate("/ats/campaigns/add-campaign?add-campaign=options");
  };
  const handleAddSchedule = () => {
    if (schedules.length < 3) {
      setSchedules([...schedules, { ...initialSchedule }]);
    }
  };
  const handleDeleteSchedule = (index) => {
    const updated = schedules.filter((_, i) => i !== index);
    setSchedules(updated);
  };
   useEffect(() => {
  if (!createCampaigns || Object.keys(createCampaigns).length === 0) return;
  const schedule = createCampaigns?.campaign_schedule;
  const firstSchedule = schedule?.schedules?.[0];
  if (!schedule || !firstSchedule) return;
  setFormData(prev => ({
    ...prev,
    scheduleStart: schedule?.start_date ?? "",
    scheduleName: firstSchedule?.name ?? "",
    timingFrom: firstSchedule?.timing?.from ?? "",
    timingTo: firstSchedule?.timing?.to ?? "",
    days: getDaysArrayFromDayMap(firstSchedule.days) ?? [],
    timezone: firstSchedule?.timezone ?? "",
  }));
}, [createCampaigns]);
  return (
    <div className="flex gap-5 mx-4 my-3 px-2 py-4 items-start">
      {/* Left side (Date range + buttons) */}
      <div className="w-fit">
        <div className="inner-section p-4 rounded">
          <FormFieldSet
            title="Start Date"
            placeholder="Select"
            type="datepicker"
            value={formData.scheduleStart}
            onChange={(value) => handleChange("scheduleStart", value)}
            error={errors.scheduleStart}
          />
          <FormFieldSet
            title="End Date"
            placeholder="Select"
            type="datepicker"
            value={formData.scheduleEnd}
            onChange={(value) => handleChange("scheduleEnd", value)}
            error={errors.scheduleEnd}
            disabled={true}
          />
        </div>
        <div className="flex flex-col gap-2 mt-2">
          {schedules.map((schedule, index) => (
            <div
              key={index}
              className="w-full border border-gray-300 flex justify-between items-center py-1.5 px-2 rounded bg-white hover:border-primary-600"
            >
              <input
                className="w-full border-0 focus:outline-none text-black bg-white placeholder:text-sm"
                placeholder={`New Schedule ${index + 1}`}
                value={schedule.scheduleName}
                onChange={(e) =>
                  handleScheduleChange(index, "scheduleName", e.target.value)
                }
              />
              {schedules.length > 1 && (
                <Button
                  type="icon"
                  icon="delete"
                  size="sm"
                  variant="text"
                  color="black"
                  onClick={() => handleDeleteSchedule(index)}
                />
              )}
            </div>
          ))}

          <Button
            icon="add"
            title="Add Schedule"
            size="sm"
            onClick={handleAddSchedule}
          />
        </div>
      </div>

      {/* Right side (Schedule details) */}
      <div className="flex flex-col flex-1 gap-y-5">
        <div className="inner-section p-3 rounded">
          <FormFieldSet
            title="Schedule Name"
            placeholder="Schedule Name"
            value={formData.scheduleName}
            onChange={(value) => handleChange("scheduleName", value)}
            error={errors.scheduleName}
          />
        </div>

        <div className="inner-section p-3 rounded grid grid-cols-3 gap-4">
          <FormFieldSet
            title="Timing"
            placeholder="From"
            type="select"
            value={formData.timingFrom}
            onChange={(value) => handleChange("timingFrom", value)}
            error={errors.timingFrom}
            options={campaignTimings}
            showSearch
          />
          <FormFieldSet
            title=" "
            placeholder="To"
            type="select"
            value={formData.timingTo}
            onChange={(value) => handleChange("timingTo", value)}
            error={errors.timingTo}
            options={campaignTimings.filter((data) => data.value !== "00:30")}
            showSearch
          />
          <FormFieldSet
            title=" "
            placeholder="Select Timezone"
            type="select"
            value={formData.timezone}
            onChange={(value) => handleChange("timezone", value)}
            error={errors.timezone}
            options={campaignTimingsZone}
            showSearch
          />
        </div>

        <div className="inner-section p-3 rounded">
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Days"
            multiple
            options={[
              { label: "Sunday", value: 0 },
              { label: "Monday", value: 1 },
              { label: "Tuesday", value: 2 },
              { label: "Wednesday", value: 3 },
              { label: "Thursday", value: 4 },
              { label: "Friday", value: 5 },
              { label: "Saturday", value: 6 },
            ]}
            values={formData.days}
            onChange={(value) => handleChange("days", value)}
            error={errors.days}
          />
        </div>

        <div className="flex justify-end">
          <Button title="Save" onClick={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default Schedule;
